import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function Fluid(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [fluidData, setfluidData] = useState([]);
  const [nurseData,setnurseData]=useState({
        "ip":'',
        "adequate":'',
        "dry":'',
        "urine":'',
        "special":'',
        "changes":'',
        "fluid_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

   useEffect(() => {
        fetchfluidData();
   }, []);
    function fetchfluidData() {
      axios.get(baseUrl + "view-fluid/" + ip_id + "/")
        .then(response => {
          setfluidData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const formSubmit = (e) => {
      e.preventDefault();
         const adequate = document.getElementById("adequate").value;
         const dry = document.getElementById("dry").value;
         const urine = document.getElementById("urine").value;
         const special = document.getElementById("special").value;
         const changes = document.getElementById("changes").value;
         const fluid_time = document.getElementById("fluid_time").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('adequate', adequate);
          _formData.append('dry', dry);
          _formData.append('urine', urine);
          _formData.append('special', special);
          _formData.append('changes', changes);
          _formData.append('fluid_time', fluid_time);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}fluid-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Details Updated Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setnurseData({
                  ip: '',
                  notes: '',
                  fluid_time: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/nurse-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-fluid/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/fluid/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
     <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
        </table>
     </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-hand-holding-droplet" aria-hidden="true" style={{ color: 'red' }}></i>
      Fluid Balance Details
    </h3>
      <form>
      <div className="row">
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Adequate: </label>
          <select className="form-control"
                name="adequate" id="adequate" >
                <option >Select</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Dry: </label>
          <select className="form-control"
                name="dry" id="dry" >
                <option >Select</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Urine Output(1ml/kg/hr): </label>
          <select className="form-control"
                name="urine" id="urine" >
                <option >Select</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Special Issue: </label>
          <select className="form-control"
                name="special" id="special" >
                <option >Select</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Any Comparative Changes : </label>
          <select className="form-control"
                name="changes" id="changes" >
                <option >Select</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
          </select>
        </div>        
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
          <DatePicker className="form-control" name="fluid_time" id="fluid_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5 mb-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
              <div className="card card-body">
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-hand-holding-droplet" aria-hidden="true" style={{ color: 'red' }}></i>
                  Fluid Balance History
                    </h3>
               <div className="table-responsive">
              <table className="erp-table-modern">
              <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                      <th>Date</th>
                      <th colSpan="5">Fluid Balance Details</th>
                      <th>Delete</th>
                    </tr>
              </thead>
              <tbody>
                {fluidData.map((dis, index) => (
                      <tr >
                        <td>{formatDateTime(dis.fluid_time)}</td>
                        <td>Adequate : {dis.adequate}</td>
                        <td>Dry : {dis.dry}</td>
                        <td>Urine Output (1ml/kg/hr): {dis.urine}</td>
                        <td>Special Issue : {dis.special}</td>
                        <td>Any Comparative Changes : {dis.changes}</td>
                        <td>
                          <button className="btn btn-danger" type="button" onClick={() => handleDelete(dis.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                </table>
              </div>
              </div>
    </div>
    </section>
    )
}

export default Fluid;